import React from 'react';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import DetailCard from './shared/detail_card';
import { formatDate } from '../../../../utilities/formatter';
import { LocationOn } from '@mui/icons-material';

const OverviewTab = ({ company }) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <DetailCard
          title="Company Details"
          icon="business"
          items={[
            { label: 'Company Type', value: company.CompanyType },
            {
              label: 'Incorporation Date',
              value: formatDate(company.IncorporationDate),
            },
            {
              label: 'Confirmation Due',
              value: formatDate(company.ConfirmationDueDate),
              status:
                new Date(company.ConfirmationDueDate) < new Date()
                  ? 'error'
                  : 'default',
            },
            {
              label: 'Accounts Due',
              value: formatDate(company.AccountsDueDate),
              status:
                new Date(company.AccountsDueDate) < new Date()
                  ? 'error'
                  : 'default',
            },
            { label: 'SIC Codes', value: company.SICCodes, isArray: true },
          ]}
        />

        <Card variant="outlined">
          <CardContent>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                display: 'flex',
                alignItems: 'center',
                fontWeight: 'bold',
              }}
            >
              <LocationOn sx={{ mr: 1, color: 'primary.main' }} />
              Registered Address
            </Typography>

            <Typography>{company.RegisteredAddress.street}</Typography>
            <Typography>{company.RegisteredAddress.city}</Typography>
            <Typography>{company.RegisteredAddress.postalCode}</Typography>
            <Typography>{company.RegisteredAddress.country}</Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} md={6}>
        <DetailCard
          title="Tax Registrations"
          icon="tax"
          items={[
            {
              label: 'Corporation Tax',
              value: company.Tax.corporationTaxRegistered
                ? 'Registered'
                : 'Not Registered',
              status: company.Tax.corporationTaxRegistered
                ? 'success'
                : 'warning',
            },
            {
              label: 'VAT Registration',
              value: company.Tax.vatRegistered
                ? 'Registered'
                : 'Not Registered',
              status: company.Tax.vatRegistered ? 'success' : 'warning',
            },
            {
              label: 'PAYE Registration',
              value: company.Tax.payeRegistered
                ? 'Registered'
                : 'Not Registered',
              status: company.Tax.payeRegistered ? 'success' : 'warning',
            },
          ]}
        />

        <DetailCard
          title="Share Structure"
          icon="shares"
          items={[
            {
              label: 'Total Shares',
              value: company.ShareStructure?.statementOfCapital?.totalShares,
            },
            {
              label: 'Total Capital',
              value: `£${company.ShareStructure?.statementOfCapital?.totalAmount}`,
            },
          ]}
          expandableSection={
            <Box sx={{ mt: 2 }}>
              {company.ShareStructure?.shareClasses?.map((shareClass, i) => (
                <DetailCard
                  key={i}
                  variant="inner"
                  items={[
                    { label: 'Type', value: `${shareClass.type} Shares` },
                    {
                      label: 'Details',
                      value: `${shareClass.totalShares} shares at £${shareClass.valuePerShare} each`,
                    },
                    {
                      label: 'Voting Rights',
                      value: shareClass.votingRights ? 'Yes' : 'No',
                    },
                    { label: 'Currency', value: shareClass.currency },
                  ]}
                />
              ))}
            </Box>
          }
        />
      </Grid>
    </Grid>
  );
};

export default OverviewTab;
